@use "../../variables" as *;

.modal {
    position: fixed;
    // breadcrumb has zIndex of 1040 and header has 1050
    z-index: 1051;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    cursor: default;

    .modal_container {
        display: flex;
        height: 100%;
        justify-content: center;
        align-items: flex-start;

        .modal_content {
            max-height: 80vh;
            background-color: $dp-white;
            padding: 20px 40px;
            border: solid grey 1px;
            height: auto;
            margin: auto;
            display: flex;
            flex-direction: column;

            .modal_header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: solid $dp-mid-grey 1px;
                padding-bottom: 16px;
                text-transform: uppercase;

                .modal_title {
                    width: 80%;
                    display: flex;
                    flex-direction: column;
                    gap: calc($default-spacing / 2);

                    .title {
                        display: block;
                        font-weight: $default-font-weight;
                        font-size: $default-header-font-size;
                        margin: 4px 50px 0 0;
                        line-height: 22px;

                        > p {
                            font-weight: normal;
                            font-size: 12px;
                            text-transform: uppercase;
                        }

                        b {
                            display: block;
                            font-size: $default-header-font-size;
                            line-height: 22px;
                        }
                    }

                    .subtitle {
                        width: 80%;
                        font-size: 12px;
                    }
                }

                .close_button {
                    align-self: flex-start;
                    height: $default-button-size;
                    width: $default-button-size;
                    border: solid $dp-mid-grey 1px;
                    transition: border-color 300ms;
                    border-radius: $default-border-radius;
                    background-color: $dp-white;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    svg {
                        margin: auto;
                    }

                    &:hover {
                        border-color: $dp-black;
                    }
                }
            }

            .modal_body {
                padding-top: 16px;
                max-height: 60vh;
                overflow-y: auto;
            }
        }
    }

    @media only screen and (min-width: $breakpoint-mobile-extra-small) {
        .modal_container {
            .modal_content {
                min-width: initial;
                max-width: initial;
            }
        }
    }

    @media only screen and (min-width: $breakpoint-mobile-min-width) {
        .modal_container {
            .modal_content {
                max-width: 70%;
                height: auto;
            }
        }
    }

    @media only screen and (min-width: $breakpoint-tablet-min-width) {
        .modal_container {
            .modal_content {
                width: auto;
            }
        }
    }
}
